import _typeof from "/home/runner/work/125-guest-ui/125-guest-ui/node_modules/@babel/runtime-corejs2/helpers/typeof";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.regexp.replace.js";
import "core-js/modules/es6.object.keys.js";
import { localize } from 'pseudo-localization'; // Match all .js files that don't start with an underscore

var files = require.context('.', false, /^(?!\.\/_).*\.js$/); // const files = require.context('.', false, /\.js$/) // All .js files


var modules = {}; // Iterate the files and add them to the modules object for exporting

files.keys().forEach(function (key) {
  if (key === './index.js') {
    return;
  } // Ignore the index.js file


  var name = key.replace(/(\.\/|\.js)/g, ''); // Create name by removing ./ and .js from key

  modules[name] = files(key).default[name]; // Add file to modules object
}); // Apply pseudolocalization before exporting

if (process.env.PSEUDOLOCALIZATION) {
  var pseudolocalization = function pseudolocalization(obj) {
    Object.keys(obj).forEach(function (key) {
      if (_typeof(obj[key]) === 'object') {
        pseudolocalization(obj[key]); // Traverse child object
      } else {
        obj[key] = localize(obj[key]); // Apply pseudolocalization

        obj[key] = obj[key].replace(/{ƞ}/g, '{n}'); // Fix {n} variable placeholders

        obj[key] = obj[key].replace(/{ẋ}/g, '{x}'); // Fix {x} variable placeholders

        obj[key] = obj[key].replace(/{ẏ}/g, '{y}'); // Fix {y} variable placeholders
      }
    });
  };

  pseudolocalization(modules);
}

export default modules;